import { renderIcon } from '@opallabs/kuiper'
import { ScheduledTime } from '../../../../../ScheduledTime'
import { sharedStyles } from '../../sharedStyles/styles'
import { styles } from './styles'

export interface Props {
  isMobile: boolean
  scheduledAt: string
  timezone: string
}

export const TwitterSingleFooter: React.FC<Props> = ({
  isMobile,
  scheduledAt,
  timezone,
}) => {
  const iconNamePrefix = `twitter-${isMobile ? 'mobile' : 'desktop'}-single-`

  return (
    <div>
      <div css={styles.getScheduledTimeWrapper(isMobile)}>
        <ScheduledTime
          css={sharedStyles.getScheduledTimeText(false)}
          dateFormat="hh:mm a · M/d/yy zzz"
          timestamp={scheduledAt}
          timezone={timezone}
        />
      </div>
      <ul css={styles.getTwitterIcons(isMobile)}>
        <li>
          {renderIcon(`${iconNamePrefix}reply`, {
            height: 18,
            width: 18,
            ariaMode: 'hidden',
          })}
        </li>
        <li>
          {renderIcon(`${iconNamePrefix}retweet`, {
            height: 15,
            width: 22,
            ariaMode: 'hidden',
          })}
        </li>
        <li>
          {renderIcon(`${iconNamePrefix}favorite`, {
            height: 17,
            width: 18,
            ariaMode: 'hidden',
          })}
        </li>
        <li>
          {renderIcon(`${iconNamePrefix}share`, {
            height: 18,
            width: 18,
            ariaMode: 'hidden',
          })}
        </li>
      </ul>
    </div>
  )
}
